<template lang="pug">
    layout.contentTransparent
        div.layoutWrapper
            v-layout(row wrap)
                v-flex(xs12)
                    div.sessionHeader

                        // Title
                        div.titleWrapper
                            h1 {{ title }}
            list(:sessions="sessions")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import VueTypes from 'vue-types';
    import { landingPages } from '~api';
    import List from './List';

    export default {
        components: {
            Layout,
            List
        },
        props: {
            theme: VueTypes.string.def(''),
            id: VueTypes.string.def('')
        },
        data() {
            return {
                sessions: undefined,
                title: ''
            };
        },
        async created() {
            const resp = await landingPages.readPublic(this.id);
            if (resp.ok) {
                const { title, description, sessionsData } = resp.data;
                this.title = title;
                this.description = description;

                const { sessionIds } = JSON.parse(sessionsData);

                this.sessions = sessionIds.filter(
                    session => session.theme === this.theme
                );
            }
        },
        methods: {
            handlePlay(sessionId) {
                const params = {
                    theme: this.theme,
                    id: this.id,
                    session: this.sessions.find(
                        session => session.id === sessionId
                    )
                };

                return this.$router.push({
                    name: 'dashboard.pagesSession',
                    params
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'
    @import "../../../../assets/style/_mixins.styl"

    .sessionHeader
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        margin: 18px 0 30px
        position: relative

        .titleWrapper h1
            padding-bottom: 0
            margin-bottom: 0
            font-size: remify(40px)
            color: $theme.white
            font-weight: 300
</style>
